module.exports = __webpack_public_path__ + "img/bj_yindao_zi.72b25628.png";